// extracted by mini-css-extract-plugin
export var intro = "index-module--intro--1BRov";
export var introTitle = "index-module--introTitle--3RGgb";
export var hero = "index-module--hero--3zbUj";
export var instructions = "index-module--instructions--2fIej";
export var introBg = "index-module--introBg--29bEB";
export var introScrollDown = "index-module--introScrollDown--3Xtl1";